import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Gavel, CreditCard, Star, Sparkles } from "lucide-react";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";

const ICON = { case: FileText, zatca: Gavel, billing: CreditCard, feedback: Star };

export default function Timeline() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/timeline").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-3xl mx-auto space-y-5 gc-fade-up">
      <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_timeline")}</h1>
      <div className="relative ps-6">
        <div className="absolute top-0 bottom-0 start-2 w-px bg-border" />
        {events.length === 0 && <div className="text-sm text-muted-foreground">—</div>}
        {events.map((e, i) => {
          const Icon = e.service_type === "zatca_audit" ? Gavel : (ICON[e.type] || FileText);
          return (
            <div key={i} className="relative mb-5">
              <div className="absolute -start-[18px] top-1 h-4 w-4 rounded-full bg-[hsl(158_64%_28%)] ring-4 ring-[hsl(158_64%_95%)]" />
              <button onClick={() => e.case_id && nav(`/app/cases/${e.case_id}`)} className="text-start w-full rounded-xl border border-border bg-card p-4 hover:border-[hsl(158_64%_28%)] transition-colors">
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4 text-[hsl(217_63%_15%)]" />
                  {e.type === "billing" ? (
                    <span className="text-sm font-medium">{t("paid")} — {e.plan_id} ({e.amount} {t("sar")})</span>
                  ) : e.type === "feedback" ? (
                    <span className="text-sm font-medium">{"★".repeat(e.rating || 5)} — {e.reference}</span>
                  ) : (
                    <span className="text-sm font-medium">{e.reference} · {lang === "ar" ? e.service_label_ar : e.service_label_en}</span>
                  )}
                </div>
                {e.to_status && <div className="text-xs text-muted-foreground mt-1">{e.action} → {e.to_status}{e.user_name ? ` · ${e.user_name}` : ""}</div>}
                <div className="text-[10px] text-muted-foreground font-mono mt-1">{(e.at || "").slice(0, 16).replace("T", " ")}</div>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
